import { useEffect, useState } from "react";
import axiosInstance from "../../../shared/api/axiosInstance";
import { trackException, LogLevel } from "../../../shared/services/appInsights";
import { AppInsightsActions, AppInsightsComponents, AppInsightsErrorTypes } from "../../../shared/services/appInsightsConstants";

export const useAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    axiosInstance
      .get("/token/status", { withCredentials: true })
      .then(() => {
        setIsAuthenticated(true);
        // No logging for successful auth check - it's expected behavior
      })
      .catch((error) => {
        setIsAuthenticated(false);
        
        // Only log unexpected authentication errors (not expired tokens)
        if (error.response?.status !== 401) {
          trackException(
            error,
            LogLevel.Warning,
            {
              component: AppInsightsComponents.USE_AUTH_HOOK,
              action: AppInsightsActions.SESSION_CHECK_FAILURE,
              errorType: AppInsightsErrorTypes.AUTH_ERROR,
              statusCode: error.response?.status || 0,
              errorMessage: error.message
            }
          );
        }
      })
      .finally(() => setIsLoading(false));
  }, []);

  return { isAuthenticated, isLoading };
};
